import styled from 'styled-components'

export const StyledActionsMenu = styled.button`
  height: 36px;
  width: 36px;
  display: inline-block;
  border: none;
  background: none;
  border-radius: 50%;
  cursor: pointer;

  path {
    fill-opacity: ${(p) => {
    // eslint-disable-next-line no-magic-numbers
    return p.isActive ? 1 : 0.5
  }};
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
  }

  &:hover {
    border: none;
    background: #FFF;
  }

  &:hover svg path {
    fill-opacity: 1;
    fill: ${(p) => {
    return p.isActive ? 'rgba(10, 161, 244, 1)' : 'rgba(32, 32, 32)'
  }};
  }

  &:active {
    border-radius: 50%;
    border: none;
    background: #FFF;
  }
`

export const ActionMenuContainer = styled.div`
  height: 36px;
  width: 36px;
  margin: ${(p) => {
    return p.margin
  }};
  position: relative;
`

export const ActionMenuDropdownMenuContainer = styled.div`
  position: ${(p) => {
    // Portaled table menus use fixed against the real viewport.
    if (p.$portal || p.table) return 'fixed'
    return p.manageCo ? 'fixed' : 'absolute'
  }};
  display: ${(p) => {
    return p.active ? 'block' : 'none'
  }};
  height: auto;
  top: ${(p) => {
    if (p.$portal || p.table) return `${p.position.top}px`
    return p.manageCo ? '' : '40px'
  }};
  left: ${(p) => {
    if (p.$portal || p.table) return `${p.position.left}px`
    return 'auto'
  }};
  right: ${(p) => {
    if (p.$portal || p.table) return 'auto'
    return p.manageCo ? '-72px' : '-135px'
  }};
  border-radius: 8px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  padding: 8px 0;
  z-index: 9999999;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 12px rgba(32, 32, 32, 0.12);
  transform: ${(p) => {
    if (p.$portal || p.table) {
      return p.upward ? 'translate(-100%, -100%)' : 'translateX(-100%)'
    }
    return p.upward ? 'translate(-133px, -100%)' : 'translate(-133px, 0px)'
  }};
`

export const ActionMenuDropdownMenuItem = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: ${(p) => {
    return p.disabled ? 'not-allowed' : 'pointer'
  }};
  opacity: ${(p) => {
    return p.disabled ? '0.3' : '1'
  }};

  ${(p) => {
    return p.color ? `color: ${p.color};` : ''
  }}
  :hover {
    background: rgba(32, 32, 32, 0.05);
  }
`

export const ActionMenuDropdownIconWrapper = styled.div`
  margin: 0 16px;
`

export const ActionMenuDropdownTextWrapper = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-right: 32px;
  white-space: nowrap;
`

export const TestDiv = styled.div`
  position: fixed;
  width: 50px;
  height: 50px;
  background: red;
  top: ${(p) => {
    return p.top
  }};
  left: ${(p) => {
    return p.left
  }}

`
